import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import './index.css';
import Home from './pages/Home.js';
import Recent from './pages/Recent.js';

import Video from './pages/Video.js';
import Upload from './pages/Upload.js';
import store from './store.js';
import { Provider } from 'react-redux';
import Liked from './pages/Liked.js';
import Delete from './pages/Delete.js';






import Category from './pages/Category.js';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <Provider store={store}>
    <BrowserRouter basename="/video">
      <Routes>
        {/* Specific Static Routes First */}
        <Route path="/" element={<Home />} />
        <Route path="/index.html" element={<Home />} />
        <Route path="/recent" element={<Recent />} />

        <Route path="/upload" element={<Upload />} />
        <Route path="/liked" element={<Liked />} />
        <Route path="/delete" element={<Delete />} />




       

        <Route path="/Category" element={<Category />} />

        {/* Dynamic Video Catch-all Route LAST */}
        <Route path="/:id" element={<Video />} />
      </Routes>
    </BrowserRouter>
  </Provider>
);
